import { IS_AUTHENTICATED_KEY } from "pages/constants/StorageKeys";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "pages/Hooks/useLocalStorage";

class AuthService {
  isAuthenticated = () => {
    return !!getLocalStorageItem(IS_AUTHENTICATED_KEY);
  };

  setAuthenticated = (isAuth) => {
    setLocalStorageItem(IS_AUTHENTICATED_KEY, isAuth.toString());
  };
}
const authService = new AuthService();

export default authService;
